import u from "./index102.mjs";
function a(e, r, t) {
  return (r = u(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
export {
  a as default
};
